define('presentation/signup/presentationObjects/signupSecurityPresentationObject',[],function() {
    return function(){
        let self = this;
        self.password = null;
        self.verificationQuestionId = null;
        self.verificationAnswer = null;
    };
});
